import React, { useContext, useState } from 'react'
import permisos from '../Tools/VerificarPermisos'
import ReporteDiarioPollo from '../Reportes/ReporteDiarioPollo';
import ReporteVentaSucursal from '../Reportes/ReporteVentaSucursal';
import ReporteTmsFreidoras from '../Reportes/ReporteTmsFreidoras';
import RequerimientoSemanal from '../Reportes/RequerimientoSemanal';
import RequerimientosPrincipal from './RequerimientosPrincipal';
import { ContextGloball } from '../Context/ContextGlobal';
import InventarioTReal from './InventarioTReal';
import HistoricoInventarioTr from './HistoricoInventarioTr';
import ProVentaDiaria from './ProVentaDiaria';
import FaltantesEnvio from './FaltantesEnvio';
import HistoricoVentaSemanal from '../Reportes/HistoricoVentaSemanal';
import Reportes from '../Reportes/Reportes';
import ReporteProductos from '../Reportes/ReporteProductos';
import AnalisisProyeccion from '../Reportes/AnalisisProyeccion';
import ReporteProyeccionDiaria from '../Reportes/ReporteProyeccionDiaria';
import StockvsInvNoche from '../Reportes/StockvsInvNoche';
import PrincipalMapaMotos from '../MapaMotos/PrincipalMapaMotos';
import ReporteRetrasos from '../Reportes/ReporteRetrasos';
import CierreCaja from './CierreCaja';
import DetalleHistoricoInv from './DetalleHistoricoInv';
import DespachoColaborador from './DespachoColaborador';
import PrincipalInventarioInicial from './PrincipalInventarioInicial';
import PrincipalEstadoSucursales from './PrincipalEstadoSucursales';

function PrinciparSupervision() {
    const { setTitulo } = useContext(ContextGloball);
    const [subVentana, setSubVentana] = useState(0);
    function mostrarSubVentana() {
        if (subVentana !== 0) {
            if (subVentana == 1) {
                return (<ReporteDiarioPollo />)
            } else if (subVentana == 2) {
                return (<ReporteVentaSucursal />)
            } else if (subVentana == 3) {
                return (<ReporteTmsFreidoras />)
            } else if (subVentana == 4) {
                return (<RequerimientoSemanal />)
            } else if (subVentana == 5) {
                return (<RequerimientosPrincipal />)
            } else if (subVentana == 6) {
                return (<InventarioTReal />)
            } else if (subVentana == 7) {
                return (<HistoricoInventarioTr />)
            } else if (subVentana == 8) {
                return (<ProVentaDiaria />)
            } else if (subVentana == 9) {
                return (<FaltantesEnvio />)
            } else if (subVentana == 10) {
                return (<HistoricoVentaSemanal />)
            } else if (subVentana == 12) {
                return (<ReporteProductos />)
            } else if (subVentana == 13) {
                return (<ReporteRetrasos />)
            } else if (subVentana == 14) {
                return (<AnalisisProyeccion />)
            } else if (subVentana == 15) {
                return (<ReporteProyeccionDiaria />)
            } else if (subVentana == 16) {
                return (<StockvsInvNoche />)
            } else if (subVentana == 17) {
                return (<PrincipalMapaMotos />)
            } else if (subVentana == 18) {
                return (<CierreCaja/>)
            } else if (subVentana == 19) {
                return (<DetalleHistoricoInv/>)
            } else if (subVentana ==20) {
                return (<DespachoColaborador/>)
            } else if (subVentana ==21){
                return (<PrincipalInventarioInicial/>)
            } else if (subVentana ==22){
                return (<PrincipalEstadoSucursales/>)
            }
        }
    }
    return (
        <>
            {subVentana == 0 &&
                <div className='container-fluid text-center'>
                    <div className='tabla-responsive'>
                        <table className='table table-sm'>
                            <thead>
                                <tr>
                                    <th className="col-2">Reportes</th>
                                    <th className="col-2">Extras</th>
                                </tr>
                            </thead>
                            <tbody>
                                {permisos.validarPermiso('31') && <tr>
                                    <td>
                                        
                                        <a className="btn btn-sm text-light text-start btn-dark bg-gradient w-100"
                                            onClick={() => { setTitulo("Repo. Diario Pollo"); setSubVentana(1) }}>
                                            <i className="fa-solid fa-drumstick-bite"></i><span className=""> Movimiento de Pollo</span></a>
                                    </td>
                                </tr>}
                                {permisos.validarPermiso('30') && <tr>
                                    <td>
                                        <a className="btn btn-sm text-light text-start btn-dark bg-gradient w-100"
                                            onClick={() => { setTitulo("Repo. Venta Sucursal"); setSubVentana(2) }}>
                                            <i className="fa-solid fa-drumstick-bite"></i><span className=""> Ventas Sucursales</span></a>
                                    </td>
                                </tr>}
                                {permisos.validarPermiso('32') && <tr>
                                    <td>
                                        <a className="btn btn-sm text-light text-start btn-dark bg-gradient w-100"
                                            onClick={() => { setTitulo("Repo. Tms Freidora"); setSubVentana(3) }}>
                                            <i className="fa-solid fa-fire-burner"></i><span className="">TMS Sucursales</span></a>
                                    </td>
                                </tr>}
                                {permisos.validarPermiso('26') && <tr>
                                    <td>
                                        <a className="btn btn-sm text-light text-start btn-dark bg-gradient w-100"
                                            onClick={() => { setTitulo("Requerimiento Semanal"); setSubVentana(4) }}>
                                            <i className="fa-solid fa-registered"></i><span className=""> Proyección Semanal</span></a>
                                    </td>
                                </tr>}
                                {permisos.validarPermiso('37') && <tr>
                                    <td>
                                        <a className="btn btn-sm text-light text-start btn-dark bg-gradient w-100"
                                            onClick={() => { setTitulo("Requerimientos"); setSubVentana(5) }}>
                                            <i className="fa-solid fa-truck-moving"></i><span className=""> Requerimientos</span></a>
                                    </td>
                                </tr>}
                                {permisos.validarPermiso('3') && <tr>
                                    <td>
                                        <a className="btn btn-sm text-light text-start btn-dark bg-gradient w-100"
                                            onClick={() => { setTitulo("Inventario Inicial"); setSubVentana(21) }}>
                                            <i className="fa-solid fa-receipt"></i><span className=""> Inventario Inicial</span></a>
                                    </td>
                                </tr>}
                                {permisos.validarPermiso('38') && <tr>
                                    <td>
                                        <a className="btn btn-sm text-light text-start btn-dark bg-gradient w-100"
                                            onClick={() => { setTitulo("Inv. Tiempo Real"); setSubVentana(6) }}>
                                            <i className="fa-solid fa-boxes-stacked"></i><span className=""> Inventario Tiempo Real</span></a>
                                    </td>
                                </tr>}
                                {permisos.validarPermiso('41') && <tr>
                                    <td>
                                        <a className="btn btn-sm text-light text-start btn-dark bg-gradient w-100"
                                            onClick={() => { setTitulo("Inv. Hist Tiempo Real"); setSubVentana(7) }}>
                                            <i className="fa-solid fa-boxes-stacked"></i><span className=""> Inv Histo. Tiempo Real</span></a>
                                    </td>
                                </tr>}
                                {permisos.validarPermiso('57') && <tr>
                                    <td>
                                        <a className="btn btn-sm text-light text-start btn-dark bg-gradient w-100"
                                            onClick={() => { setTitulo("Reporte Consumo"); setSubVentana(19) }}>
                                            <i className="fa-solid fa-boxes-stacked"></i><span className=""> Reporte Consumo</span></a>
                                    </td>
                                </tr>}
                                {permisos.validarPermiso('51') && <tr>
                                    <td>
                                        <a className="btn btn-sm text-light text-start btn-dark bg-gradient w-100"
                                            onClick={() => { setTitulo("Venta Semanal"); setSubVentana(10) }}>
                                            <i className="fa-solid fa-boxes-stacked"></i><span className=""> Venta Semanal</span></a>
                                    </td>
                                </tr>}
                                {permisos.validarPermiso('42') && <tr>
                                    <td>
                                        <a className="btn btn-sm text-light text-start btn-dark bg-gradient w-100"
                                            onClick={() => { setTitulo("Proyección Ventas Diarias"); setSubVentana(8) }}>
                                            <i className="fa-solid fa-shop-lock"></i><span> Proyección Ventas Diarias</span></a>
                                    </td>
                                </tr>}
                                {permisos.validarPermiso('44') && <tr>
                                    <td>
                                        <a className="btn btn-sm text-light text-start btn-dark bg-gradient w-100"
                                            onClick={() => { setTitulo(" Faltantes de Envio Sucursales"); setSubVentana(9) }}>
                                            <i className="fa-solid fa-person-hiking"></i><span> Faltantes de Envios</span></a>
                                    </td>
                                </tr>}
                                {permisos.validarPermiso('5') && <tr>
                                    <td>
                                        <a className={`btn btn-sm text-light text-start btn-dark bg-gradient w-100`}
                                            onClick={() => { setSubVentana(12); setTitulo('Reportes Productos Almacen'); }}>
                                            <i className="fa-solid fa-boxes-stacked"></i><span className=""> Producto Almacen</span></a>
                                    </td>
                                </tr>}
                                {permisos.validarPermiso('49') && <tr>
                                    <td>
                                        <a className={`btn btn-sm text-light text-start btn-dark bg-gradient w-100`}
                                            onClick={() => { setSubVentana(14); setTitulo('Analisis De Proyección'); }}>
                                            <i className="fa-solid fa-chart-pie"></i><span className="ms-1 "> Analisis Proyeccion</span></a>
                                    </td>
                                </tr>}
                                {permisos.validarPermiso('50') && <tr>
                                    <td>
                                        <a className={`btn btn-sm text-light text-start btn-dark bg-gradient w-100`}
                                            onClick={() => { setSubVentana(15); setTitulo('Proyección Futura'); }}>
                                            <i className="fa-solid fa-shop-lock"></i><span className="ms-1 "> Proyección Futura</span></a>
                                    </td>
                                </tr>}
                                {permisos.validarPermiso('51') && <tr>
                                    <td>
                                        <a className={`btn btn-sm text-light text-start btn-dark bg-gradient w-100`}
                                            onClick={() => { setSubVentana(16); setTitulo('Stock vs Inv. Noche'); }}>
                                            <i className="fa-solid fa-cubes-stacked"></i><span className="ms-1 "> Stock vs Inv. Noche</span></a>
                                    </td>
                                </tr>}
                                {permisos.validarPermiso('28') && <tr>
                                    <td>
                                        <a className={`btn btn-sm text-light text-start btn-dark bg-gradient w-100`}
                                            onClick={() => { setSubVentana(17); setTitulo('Mapa Motos'); }}>
                                            <i className="fa-solid fa-map-location-dot"></i><span className="ms-1 "> Mapa Motos</span></a>
                                    </td>
                                </tr>}
                                {permisos.validarPermiso('55') && <tr>
                                    <td>
                                        <a className={`btn btn-sm text-light text-start btn-dark bg-gradient w-100`}
                                            onClick={() => { setSubVentana(13); setTitulo('Retrasos Personal'); }}>
                                            <i className="fa-solid fa-person-circle-exclamation"></i><span className="ms-1 "> Retrasos Personal</span></a>
                                    </td>
                                </tr>}
                                {permisos.validarPermiso('56')&&<tr>
                                    <td>
                                        <a className={`btn btn-sm text-light text-start btn-dark bg-gradient w-100`}
                                            onClick={() => { setSubVentana(18); setTitulo('Cierres de caja'); }}>
                                            <i className="fa-solid fa-shop-lock"></i><span className="ms-1 "> Cierres de Caja</span></a>
                                    </td>
                                </tr>}
                                {permisos.validarPermiso('58')&&<tr>
                                    <td>
                                        <a className={`btn btn-sm text-light text-start btn-dark bg-gradient w-100`}
                                            onClick={() => { setSubVentana(20); setTitulo('Despacho x Colaborador'); }}>
                                            <i className="fa-solid fa-users-rectangle"></i><span className="ms-1 "> Despacho x Colaborador</span></a>
                                    </td>
                                </tr>}
                                {permisos.validarPermiso('59')&&<tr>
                                    <td>
                                        <a className={`btn btn-sm text-light text-start btn-dark bg-gradient w-100`}
                                            onClick={() => { setSubVentana(22); setTitulo('Estado Sucursales'); }}>
                                            <i className="fa-solid fa-building-lock"></i><span className="ms-1 "> Estado Sucursales</span></a>
                                    </td>
                                </tr>}
                            </tbody>
                        </table>
                    </div>
                </div>
            }
            {mostrarSubVentana()}
            {subVentana !== 0 && <button className='btn text-danger btn-flotante' onClick={() => { setTitulo('SUPERVISIÓN'); setSubVentana(0) }}><i className="fa-solid fa-circle-xmark fa-2xl"></i></button>}
        </>
    )
}

export default PrinciparSupervision